import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { Tab, Tabs, Typography } from '@mui/material';
import IntlMessages from '@projectK/helpers/IntlMessages';
import ActivityHistory from './ActivityHistory';
import { Fonts } from '@projectK/constants';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import AppCard from '@projectK/components/AppCard';
import FeedbackReportTable from './FeedbackReports';
import { useRolePermissions, hasPermission } from '@projectK/context/RolesProvider';

const ManageHistory = () => {
  const companyTheme = CompanyTheme();
  const { rolePermissions } = useRolePermissions();

  // Build available tabs dynamically
  const availableTabs = [];
  if (hasPermission(rolePermissions, 'Player Reports - Attendance Summary', 'read')) {
    availableTabs.push({
      label: <IntlMessages id="common.attendancesummary" />,
      component: <ActivityHistory />,
    });
  }
  if (hasPermission(rolePermissions, 'Player Reports - Feedback Report', 'read')) {
    availableTabs.push({
      label: 'Feedback Reports',
      component: <FeedbackReportTable />,
    });
  }

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <AppCard>
      <Typography
        component="h3"
        sx={{
          marginBottom: 2,
          fontSize: 16,
          fontWeight: Fonts.BOLD,
          color: companyTheme ? companyTheme.primary.main : 'text.primary',
        }}
      >
        <IntlMessages id="common.history" />
      </Typography>

      <Typography component="h3">
        This page shows a complete history of the activities you've attended
      </Typography>

      <Tabs
        value={value}
        onChange={handleChange}
        sx={{
          '& .crMuiTab': {
            textTransform: 'capitalize',
            p: 0,
          },
        }}
      >
        {availableTabs?.map((tab, index) => (
          <Tab
            key={index+0}
            className="crMuiTab"
            style={{ marginRight: '25px' }}
            label={tab.label}
          />
        ))}
      </Tabs>

      <Box sx={{ mt: 4 }}>
        {availableTabs?.[value]?.component}
      </Box>
    </AppCard>
  );
};

export default ManageHistory;
